const OSS = require('ali-oss');
import api from '../axios/api'

let params = {}, client = {}, err = false;

const headers = {
    // 指定该Object被下载时的网页缓存行为。
    "Cache-Control": "no-cache",
    // 指定该Object被下载时的名称。
    "Content-Disposition": "example.txt",
    // 指定该Object被下载时的内容编码格式。
    "Content-Encoding": "utf-8",
    // 指定过期时间，单位为毫秒。
    "Expires": "1000",
    // 指定Object的存储类型。
    "x-oss-storage-class": "Standard",
    // 指定Object标签，可同时设置多个标签。
    "x-oss-tagging": "Tag1=1&Tag2=2",
    // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
    "x-oss-forbid-overwrite": "true",
};

/*
    初始化alioss客户端，有效期1个小时
*/ 
function initClient() {
    return new Promise(async (resolve, reject) => {
        const now = new Date().getTime();
        const expiration = params.expiration ? (params.expiration * 1000) - now : 0;
        if(expiration > 1000) {
            setParams(params);
            resolve(client);
        }else{
            api.getAliParams({}).then(data => {
                if(data.code == 0){
                    err = true;
                    params = data.data;
                    // 实例化一个上传客户端
                    setParams(params);
                    resolve(client);
                }else{
                    err = false;
                }
            })
        }
    });
}

function setParams(params) {
    client = new OSS({
        region: params.region,
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: params.access_key,
        accessKeySecret: params.access_secret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: params.token,
        // 填写Bucket名称。
        bucket: params.bucket,
        refreshSTSToken: true,
        refreshSTSTokenInterval: 3600000, // 刷新间隔为1小时
        timeout: 300000
        // expiration: params.expiration
    })
}




export default initClient;


// WEBPACK FOOTER //
// ./src/aliOss/config.js